import PageHero from "../components/PageHero";
import SmartLink from "../components/SmartLink";
import { ArrowRightIcon } from "../components/Icons";
import { docsPage } from "../lib/docs";

export default function DocsPage() {
  return (
    <>
      <PageHero
        eyebrow={docsPage.eyebrow}
        title={docsPage.title}
        intro={docsPage.intro}
        actions={
          <>
            <SmartLink href={docsPage.primaryCta.href} className="btn-primary">
              {docsPage.primaryCta.label}
              <ArrowRightIcon />
            </SmartLink>
            <SmartLink href={docsPage.secondaryCta.href} className="btn-ghost">
              {docsPage.secondaryCta.label}
            </SmartLink>
          </>
        }
      />

      {/* Getting started */}
      <section className="section-pad bg-white">
        <div className="container-page">
          <div className="max-w-2xl">
            <span className="eyebrow">Setup</span>
            <h2 className="h-section mt-4">{docsPage.gettingStartedHeading}</h2>
            <p className="lead">{docsPage.gettingStartedIntro}</p>
          </div>

          <ol className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {docsPage.steps.map((step) => (
              <li key={step.step} className="card h-full p-6 shadow-card">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-brand-500 text-sm font-bold text-white">
                  {step.step}
                </span>
                <h3 className="mt-5 text-base font-semibold text-ink">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-muted">{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* Browse by topic */}
      <section className="section-pad bg-ink-soft">
        <div className="container-page">
          <div className="max-w-2xl">
            <span className="eyebrow">Guides</span>
            <h2 className="h-section mt-4">{docsPage.topicsHeading}</h2>
            <p className="lead">{docsPage.topicsIntro}</p>
          </div>

          <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {docsPage.topics.map((topic) => (
              <div key={topic.title} className="card p-6 shadow-card">
                {topic.badge && (
                  <span className="inline-flex items-center rounded-full bg-brand-50 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-brand-700">
                    {topic.badge}
                  </span>
                )}
                <h3 className="mt-4 text-base font-semibold text-ink">{topic.title}</h3>
                <ul className="mt-4 space-y-2.5 border-t border-ink-line pt-4">
                  {topic.items.map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-sm text-ink-muted">
                      <span
                        aria-hidden="true"
                        className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-300"
                      />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Common questions */}
      <section className="section-pad bg-white">
        <div className="container-page">
          <div className="max-w-2xl">
            <span className="eyebrow">FAQ</span>
            <h2 className="h-section mt-4">{docsPage.faqHeading}</h2>
          </div>

          <dl className="mt-12 grid gap-6 md:grid-cols-2">
            {docsPage.faqs.map((faq) => (
              <div key={faq.q} className="card p-6 shadow-card">
                <dt className="text-base font-semibold text-ink">{faq.q}</dt>
                <dd className="mt-2 text-sm leading-relaxed text-ink-muted">{faq.a}</dd>
              </div>
            ))}
          </dl>
        </div>
      </section>

      {/* Help */}
      <section className="section-pad bg-ink-soft">
        <div className="container-page">
          <div className="card mx-auto max-w-3xl p-8 text-center shadow-card sm:p-12">
            <h2 className="text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              {docsPage.helpHeading}
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-ink-muted">
              {docsPage.helpBody}
            </p>
            <SmartLink href={docsPage.helpCta.href} className="btn-primary mt-8">
              {docsPage.helpCta.label}
              <ArrowRightIcon />
            </SmartLink>
          </div>
        </div>
      </section>
    </>
  );
}
